import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type RdProjectDetailAnalyticIds = {
  nameId: string;
  descriptionId: string;
  productId: string;
  projectOwnerId: string;
  clearProductBtnId: string;
  clearProjectOwnerBtnId: string;
};

export const useRdProjectDetailAnalyticIds = (): RdProjectDetailAnalyticIds => ({
  nameId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_NAME),
  descriptionId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_DESCRIPTION),
  productId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_PRODUCT),
  projectOwnerId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_PROJECT_OWNER),
  clearProductBtnId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_PRODUCT_CLEAR_BUTTON),
  clearProjectOwnerBtnId: useAnalyticId(AnalyticIdentifier.RD_PROJECT_DETAIL_PROJECT_OWNER_CLEAR_BUTTON),
});
